
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#55a3ff","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 510 510"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M229.5 382.5h51v-153h-51v153zM255 0C114.75 0 0 114.75 0 255s114.75 255 255 255 255-114.75 255-255S395.25 0 255 0zm0 459c-112.2 0-204-91.8-204-204S142.8 51 255 51s204 91.8 204 204-91.8 204-204 204zm-25.5-280.5h51v-51h-51v51z"}})])
          )
        }
      }
    